import React, { useCallback, useEffect, useState } from 'react';
import { addWidgetsV2Scripts } from '../views/Partials/Blocky/v2/widgets-v2/helpers/helpers';
import HttpService from '../services/rest/HttpService';
import { useQuery } from 'react-query';
import { REFETCH_TOKENS_EXPIRY_TIME } from '../global-helpers/global.constants';
import { isDateInFuture, minutesToMilliseconds } from '../global-helpers/global-dates.helper';
import { useSelector } from 'react-redux';
import { setApiTokens } from '../utils/localStorage';

export const ScriptsInjector: React.FunctionComponent = () => {
	const projectDomain = useSelector(
		(state: any) => state && state.project && state.project.currentProject && state.project.currentProject.domain,
	);
	const [refetchingTokensExpiryTime, setRefetchingTokensExpiryTime] = useState<string>(
		localStorage.getItem(REFETCH_TOKENS_EXPIRY_TIME) || new Date().toISOString(),
	);

	useEffect(() => {
		addWidgetsV2Scripts();
	}, []);

	const areTokensExpired = useCallback(() => isDateInFuture(refetchingTokensExpiryTime), [refetchingTokensExpiryTime]);

	const calculateRefetchInterval = useCallback(() => {
		if (areTokensExpired()) return 0;

		const minutesExpiryRange = minutesToMilliseconds(1);
		const now = new Date().getTime();
		const expiry = new Date(refetchingTokensExpiryTime).getTime();
		const timeUntilExpiry = Math.max(0, expiry - now);

		if (timeUntilExpiry < minutesExpiryRange) return 0;
		return timeUntilExpiry - minutesExpiryRange;
	}, [refetchingTokensExpiryTime, areTokensExpired]);

	useQuery(['tokens'], HttpService.getAuthTokens, {
		cacheTime: 0,
		staleTime: 0,
		refetchInterval: calculateRefetchInterval(),
		refetchIntervalInBackground: true,
		retry: 3,
		onSettled: (data) => {
			if (data && data.data && data.data.expires_at && data.data.access_token) {
				const expiryTime = data.data.expires_at;
				localStorage.setItem(REFETCH_TOKENS_EXPIRY_TIME, expiryTime);
				setRefetchingTokensExpiryTime(expiryTime);
				setApiTokens(data.data.access_token);
			}
		},
		enabled: Boolean(projectDomain),
	});

	return null;
};
